import { ErrorMessage, Field, Form, Formik } from "formik";
import { useState } from "react";
// Images
import { Link } from "react-router-dom";
import { ForgotPasswordInitialValues } from "../../../constants/formInitialValues";
import { useLazyResetPasswordQuery } from "../../../store/services/AuthService";
import { getErrorMessage } from "../../../utils/utils";
import { ForgotPasswordValidationSchema } from "../../../validations";
import { AuthWrapper } from "../../components/common/wrappers/AuthWrapper";

function ForgotPassword() {
  const [resetPassword, { isLoading }] = useLazyResetPasswordQuery();
  const [emailSent, setEmailSent] = useState(false);
  const handleSubmit = async (values, { setSubmitting }) => {
    const { email } = values || {};

    try {
      const response = await resetPassword({
        email,
      }).unwrap();
      if (!response?.succeeded) {
        getErrorMessage(response?.errors?.[0]);
      } else {
        setEmailSent(true);
      }
    } catch (error) {
      console.log("🚀 ~ handleSubmit ~ error:", error);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <AuthWrapper>
      {emailSent ? (
        <>
          <div>
            <h4 className="fs-20">Email Sent</h4>
            <p className="mb-4">Please check your email to reset password!</p>
          </div>
          <div className="btn btn-link p-0 mt-2 mb-4 text-decoration-none text-primary">
            <p>
              <Link
                className="text-primary"
                to="/login"
              >
                ← Back to Login
              </Link>
            </p>
          </div>
        </>
      ) : (
        <div>
          <h4 className="fs-20 mb-4 mt-4">Forgot Password</h4>
          <p className="mb-4">Enter your email address to receive password reset instructions</p>
          <Formik
            initialValues={ForgotPasswordInitialValues}
            validationSchema={ForgotPasswordValidationSchema}
            onSubmit={handleSubmit}
          >
            {({ errors, touched, isSubmitting }) => (
              <Form className="d-flex flex-column gap-3">
                {/* Email */}
                <div>
                  <label
                    className={`form-label ${touched.email && errors.email ? "text-danger" : ""}`}
                  >
                    <strong>Email</strong>
                  </label>
                  <Field
                    type="email"
                    name="email"
                    className={`form-control ${
                      touched.email && errors.email ? "border border-danger" : ""
                    }`}
                  />
                  <ErrorMessage
                    name="email"
                    component="div"
                    className="text-danger small mt-1"
                  />
                </div>

                <button
                  type="submit"
                  className="btn btn-primary btn-block"
                  disabled={isSubmitting || isLoading}
                >
                  {isLoading ? "Processing..." : "Send Reset Link"}
                </button>
              </Form>
            )}
          </Formik>
          <div className="new-account mt-3">
            <p>
              Remember your password?{" "}
              <Link
                className="text-primary"
                to="/login"
              >
                Sign in
              </Link>
            </p>
          </div>
        </div>
      )}
    </AuthWrapper>
  );
}

export default ForgotPassword;
